import { Icon } from "./Icon.tsx";

/** "Close project" icon (door + exit arrow). */
export function CloseProjectIcon() {
  return (
    <Icon>
      <path d="M10 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5" />
      <path d="M15 8l4 4-4 4M19 12H9" />
    </Icon>
  );
}
